/* eslint-disable @typescript-eslint/no-explicit-any */

var getTabsMeta = function getTabsMeta(tabsNode) {
  var scrollLeftNormalized = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (tabsNode) {
    var rect = tabsNode.getBoundingClientRect();
    // create a new object with ClientRect class props + scrollLeft
    return {
      clientWidth: tabsNode.clientWidth,
      scrollLeft: tabsNode.scrollLeft,
      scrollTop: tabsNode.scrollTop,
      scrollLeftNormalized: scrollLeftNormalized,
      scrollWidth: tabsNode.scrollWidth,
      top: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      right: rect.right
    };
  }
  return;
};
var getChildrenElementIndex = function getChildrenElementIndex(children, valueToIndex, value, moreIncludesList) {
  return moreIncludesList !== null && moreIncludesList !== void 0 && moreIncludesList.includes(value) ? children.length - 1 : valueToIndex.get(value);
};
var findChildElement = function findChildElement(tabListNode, value, valueToIndex, moreIncludesList, hideIndicator) {
  var children = tabListNode === null || tabListNode === void 0 ? void 0 : tabListNode.children;
  if (children) {
    var tab = children[getChildrenElementIndex(children, valueToIndex, value, moreIncludesList)];
    if (!hideIndicator && process.env.NODE_ENV !== 'production') {
      if (!tab) {
        console.error(["Tui: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
      }
    }
    return tab;
  }
  return;
};
var getTabMeta = function getTabMeta(orientation, tabListNode, valueToIndex, value, moreIncludesList, hideIndicator) {
  if (tabListNode && value !== undefined && value !== null) {
    var children = tabListNode.children || [];
    if (children.length > 0) {
      var tab = findChildElement(tabListNode, value, valueToIndex, moreIncludesList, hideIndicator);
      if (tab) {
        var _tab$firstElementChil;
        return orientation === 'vertical' ? (_tab$firstElementChil = tab.firstElementChild) === null || _tab$firstElementChil === void 0 ? void 0 : _tab$firstElementChil.getBoundingClientRect() : tab.getBoundingClientRect();
      }
    }
  }
  return;
};

export { getTabMeta, getTabsMeta };
//# sourceMappingURL=tab-utils.esm.js.map
